'use client'

import React from 'react'

import BackgroundImageView from '@/components/Page/Teaser/Introduction/BackgroundImageView'
import ButtonView from '@/components/Page/Teaser/Introduction/Debut/ButtonView'
import DebutView from '@/components/Page/Teaser/Introduction/Debut/DebutView'
import TextView from '@/components/Page/Teaser/Introduction/Debut/TextView'

export default function IntroductionView({ eyecatch }: { eyecatch: string }) {
  const speed = 1000 * 0.5
  const rootMargin = '0px 0px -3% 0px'

  return (
    <DebutView
      key={'DebutView'}
      speed={speed}
      leftBgComponent={
        <>
          <BackgroundImageView speed={speed} rootMargin={rootMargin} processChangeAnimation={true} />
        </>
      }
      rightBgComponent={
        <>
          <BackgroundImageView speed={speed} rootMargin={'0px 0px 98.5% 0px'} />
        </>
      }
      leftComponent={<ButtonView />}
      rightComponent={<TextView eyecatch={eyecatch} />}
      extraRightComponent={null}
    />
  )
}
